module.exports = __webpack_public_path__ + "static/media/admin-lock.01ef08c8.svg";